module.exports = __webpack_public_path__ + "media/honey-icons/icon-livingroom-983568d7.svg";